import React from "react";
import AppDayHeader from "../../../../components/AppDayHeader";
import { IconNote } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const weekDays = [
  { weekday: "Montag", day: "03.08." },
  { weekday: "Dienstag", day: "04.08." },
  { weekday: "Mittwoch", day: "05.08.", today: true },
  { weekday: "Donnerstag", day: "06.08.", holiday: true, marker: <IconNote fontSize="inherit" /> },
  { weekday: "Freitag", day: "07.08." },
  { weekday: "Samstag", day: "08.08.", weekend: true },
  { weekday: "Sonntag", day: "09.08.", weekend: true },
];

const monthDays = [
  { weekday: "Mo", day: "1" },
  { weekday: "Di", day: "2" },
  { weekday: "Mi", day: "3", today: true },
  { weekday: "Do", day: "4", holiday: true },
  { weekday: "Fr", day: "5" },
  { weekday: "Sa", day: "6", weekend: true },
  { weekday: "So", day: "7", weekend: true },
  { weekday: "Mo", day: "8" },
  { weekday: "Di", day: "9" },
  { weekday: "Mi", day: "10" },
];

const notes = [
  "Der Spaltenkopf jedes Tages-Rasters: Schichtplan, Verfügbarkeit und Bedarf teilen sich dieselbe Optik.",
  "Wochenansicht: Wochentag ausgeschrieben, darunter das Datum (03.08.).",
  "Monatsansicht: Wochentagskürzel, darunter nur die Tageszahl.",
];

const highlights = [
  "weekend und holiday färben die Spalte, today setzt die Unterstreichung.",
  "marker nimmt ein kleines Icon oben rechts auf (z. B. Tagesnotiz).",
];

export default function DayHeadersDocs() {
  return (
    <DocsSectionCard title="Day Headers">
      <div className="ds-docs-day-header-section">
        <DocsPreviewPanel title="AppDayHeader">
          <div className="ds-docs-preview-surface">
            <div className="ds-docs-day-header-row__label">Wochenansicht</div>
            <div className="ds-docs-day-header-grid" style={{ "--ds-docs-day-header-columns": weekDays.length }}>
              {weekDays.map((entry) => (
                <AppDayHeader key={entry.day} view="week" {...entry} />
              ))}
            </div>

            <div className="ds-docs-day-header-row__label">Monatsansicht</div>
            <div className="ds-docs-day-header-grid" style={{ "--ds-docs-day-header-columns": monthDays.length }}>
              {monthDays.map((entry, index) => (
                <AppDayHeader key={`${entry.day}-${index}`} view="month" {...entry} />
              ))}
            </div>

            <div className="ds-docs-day-header-row__label">Klickbar</div>
            <div className="ds-docs-day-header-grid" style={{ "--ds-docs-day-header-columns": 3 }}>
              <AppDayHeader view="week" weekday="Montag" day="03.08." onClick={() => {}} />
              <AppDayHeader view="week" weekday="Samstag" day="08.08." weekend onClick={() => {}} />
              <AppDayHeader view="week" weekday="Donnerstag" day="06.08." holiday onClick={() => {}} />
            </div>
          </div>
        </DocsPreviewPanel>
        <DocsNiceToKnow items={notes} highlightItems={highlights} />
      </div>
    </DocsSectionCard>
  );
}
